import "./fonts.css";
import { render } from "preact";
import { App } from "./ui/App";
import { bootstrap } from "./actions";
import { composerDirty, composerPendingSend } from "./state";
import { applyPrefsToDocument } from "./prefs";

applyPrefsToDocument();

const root = document.getElementById("app");
if (root) {
  render(<App />, root);
  void bootstrap();
}

// Warn before closing the tab while the composer has unsaved changes or a
// message is still waiting out its undo window.
window.addEventListener("beforeunload", (e) => {
  if (composerDirty.value || composerPendingSend.value) {
    e.preventDefault();
    // Modern browsers ignore custom messages for security reasons
    // but still show a generic confirmation dialog when returnValue is set.
    e.returnValue = "You have unsaved changes. Do you really want to leave?";
  }
});
